<template>
    <div class="compo-form-body">
        <div class="choice-item">
            <input type="radio" class="buttonbox" id="instantly" ref="instantly" value="즉시발송" name="checkedWhen" v-model="checkedWhen">
            <label class="label-checkbox label-checkbox__order" for="instantly">
                <span>즉시발송</span>
                <IconCheck></IconCheck>
            </label>
        </div>
        <div class="choice-item">
            <input type="radio" class="buttonbox" id="reservation" ref="reservation" value="예약발송" name="checkedWhen" v-model="checkedWhen">
            <label class="label-checkbox label-checkbox__order" for="reservation">
                <span>예약발송</span>
                <IconCheck></IconCheck>
            </label>            
            <input type="datetime-local" ref="datetimeLocal" id="datetimeLocal" v-model="datetimeLocal" @input="directlyInput" @click="clickDatetimeLocalInput" @change="compareDateLocalTime" class="form-control">
        </div>
        <p class="choice-item-info">발송일은 주문일로부터 7일 이내로 선택 가능합니다.</p>
        <!-- Date Picker 플러그인 마크업 
        <div class="choice-item">
            <input type="radio" class="buttonbox" id="reservation" ref="reservation" value="예약발송" name="checkedWhen" v-model="checkedWhen">
            <label class="label-checkbox label-checkbox__order" for="reservation">
                <span>예약발송</span>
                <IconCheck></IconCheck>
            </label>
            <date-picker class="form-control"
                v-model="datetimeLocal"
                :get-classes="getRangeClasses"
                :default-value="end || new Date()"
                :disabled-date="disabledStartDate"
                :disabled-time="disabledStartTime"
                type="datetime"
            ></date-picker>
        </div> -->
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { addZero } from '@/util';

export default {

    data() {
        return {
            checkedWhen: '즉시발송',
            datetimeLocal: null, // 예약발송 기본 세팅 현재 날짜
            datetimeLocalFormat: null,
            isChangeBookingDate: false,
        }
    },
    
    components: {
        IconCheck: () => import('@/components/svg-icon/IconCheck.vue'), // 체크 아이콘
    },

    computed: {
        ...mapState({
            userData: state => state.userData,
            userNo: state => state.userNo,
            tempBookingDate: state => state.tempBookingDate,
            visibleBookingLayerPopup: state => state.modalStore.modalsObj.visibleBookingLayerPopup,
        }),	
    },

    watch: {
        tempBookingDate() {
            if(this.tempBookingDate){
                this.datetimeLocal = new Date(this.tempBookingDate.substring(0,19).concat('Z')).toISOString().substring(0, 16);
                this.datetimeLocalFormat = this.datetimeLocal.substring(0,4) + "년 " + this.datetimeLocal.substring(5,7) + "월 " + this.datetimeLocal.substring(8,10) + "일 ";
                this.checkedWhen = '';
                document.getElementById('reservation').checked = true;
            } else {
                document.getElementById('instantly').checked = true;    
            }         
        },

        datetimeLocal() {
            let year = 0;
            let month = 0;
            let date = 0;
            let amPm = '';
            let hour = 0;
            let minute = 0;

            this.datetimeLocal = new Date(this.datetimeLocal.substring(0,19).concat('Z')).toISOString().substring(0, 16);
            year = addZero(Number(this.datetimeLocal.substring(0,4)));
            month = addZero(Number(this.datetimeLocal.substring(5,7)));
            date = addZero(Number(this.datetimeLocal.substring(8,10)));
            hour = addZero(Number(this.datetimeLocal.substring(11,13)));
            minute = addZero(Number(this.datetimeLocal.substring(14,16)));

            if(this.datetimeLocal.substring(11,13) > 12) {
                amPm = '오후'
                hour = addZero(hour - 12);          
            } else {
                amPm = '오전'
            }

            this.datetimeLocalFormat = year + "년 " + month + "월 " + date + "일 " + amPm + " " + hour + ":" + minute;
            this.$emit('datetimeLocalFormat', this.datetimeLocalFormat)
            this.$emit('datetimeLocal', this.datetimeLocal)
        },

        // 예약발송, 즉시발송 여부
        checkedWhen() { 
            this.$emit('checkedWhen', this.checkedWhen);
        }
    },

    methods: {
        directlyInput() { // 예약발송 날짜 클릭 시 체크박스 동시에 선택
            this.$refs.reservation.checked = true;
            // console.log(this.$refs.reservation.checked);
        },
        // checkRadioBtn() { 
        //     // if(document.getElementById('instantly').checked) {
        //     //     // document.getElementById('datetimeLocal').disabled = true;
        //     //     this.$refs.datetimeLocal.disabled = true;
        //     // } else {
        //     //     // document.getElementById('datetimeLocal').disabled = false;
        //     //     this.$refs.datetimeLocal.disabled = false;
        //     // }
        //     console.log(this.checkedWhen);
        //     eventBus.$emit('shippingDate', this.checkedWhen);
        // },
        setMinMaxValue() { 
            let dateElement = document.getElementById('datetimeLocal');
            let date = new Date().getTime() - new Date().getTimezoneOffset() * 60000;  // 한국 표준시 설정값
            // 현재날짜
            let currentDate = new Date(date).toISOString().slice(0, -8);  // 초단위 삭제
            // 6일 뒤
            let laterDate = new Date(date + 1000 * 60 * 60 * 24 * 6).toISOString().slice(0, -8);

            dateElement.setAttribute("min", currentDate);
            // console.log(currentDate);
            dateElement.setAttribute("max", laterDate);
            // console.log(laterDate);
        },

        // 날짜 입력 인풋 클릭
        clickDatetimeLocalInput(){
            this.setMinMaxValue();
            if(this.visibleBookingLayerPopup){ // 일정변경 팝업이 노출되었을 때
                this.$parent.checkClickedDatetimeLocal(); // $parent: 부모 컴포넌트인 일정변경 컴포넌트의 메서드 checkClickedDatetimeLocal() 사용
            }
        },

        // datetimelocal에서 현재시간보다 이전이면 현재시간으로 세팅
        compareDateLocalTime() {
            let dateElement = document.getElementById('datetimeLocal');
            let date = new Date().getTime() - new Date().getTimezoneOffset() * 60000;
            let currentDate = new Date(date).toISOString().slice(0, -8);

            if(dateElement.value < currentDate) {
                alert('현재시간보다 이전 시간은 선택할 수 없습니다.');
                dateElement.value = currentDate;
            }            
        },

        
    },

    mounted() {
        if(this.tempBookingDate){
            this.datetimeLocal = new Date(this.tempBookingDate.substring(0,19).concat('Z')).toISOString().substring(0, 16);
            this.datetimeLocalFormat = this.datetimeLocal.substring(0,4) + "년 " + this.datetimeLocal.substring(5,7) + "월 " + this.datetimeLocal.substring(8,10) + "일 ";
            this.checkedWhen = '';
            document.getElementById('reservation').checked = true;   
        }     
    },
}

</script>

<style lang="scss"> /* date picker 스타일링 수정을 위해서 scope 해제 */
@import '@/assets/css/order.scss';

</style>